<div class="input-group clearButton {{classInputName}}">
  <input type="text" class="form-control filter-item" [(ngModel)]="value"
    (keyup)="onKeyup()" (ngModelChange)="onInputChange()"
    (keypress)="onKeyPress($event)"
    [attr.maxLength]="maxLength">
    @if (haveValue()) {
      <div class="input-group-append">
        <button class="btn" type="button" id="clearButton" (click)="onClear()">
          <i class="pi pi-times"></i>
        </button>
      </div>
    }
  </div>